import * as React from 'react';
import * as ReactDOM from 'react-dom';

import './Portal.scss';

interface PortalProps {
  elementId: string;
}

export class Portal extends React.Component<PortalProps, {}> {
  componentDidUpdate() {
    this.extend();
  }

  componentDidMount() {
    this.extend();
  }

  componentWillUnmount() {
    this.unextend();
  }

  render() {
    return null;
  }

  get extension() {
    return document.getElementById(this.props.elementId);
  }

  private extend() {
    const extension = this.extension;

    if (extension) {
      const children = this.props.children as JSX.Element;
      ReactDOM.unstable_renderSubtreeIntoContainer(this, children, extension);
    }
  }

  private unextend() {
    const extension = this.extension;
    if (extension) {
      ReactDOM.unmountComponentAtNode(extension);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Portal/Portal.tsx